import { render, staticRenderFns } from "./ProductEditAwsDocuments.vue?vue&type=template&id=4727ba39"
import script from "./ProductEditAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./ProductEditAwsDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4727ba39')) {
      api.createRecord('4727ba39', component.options)
    } else {
      api.reload('4727ba39', component.options)
    }
    module.hot.accept("./ProductEditAwsDocuments.vue?vue&type=template&id=4727ba39", function () {
      api.rerender('4727ba39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditAwsDocuments.vue"
export default component.exports